import { QuestionnaireResponseItem } from '@medplum/fhirtypes'
import { BaseSubsectionAdapter } from 'components/Assessments/adapters/BaseSubsectionAdapter'
import { AdapterOptions, FlatAnswerMutation } from 'components/Assessments/adapters/types'
import { getAnswerValuesFromItems } from 'components/Assessments/helpers'
import { SocFormData } from 'components/Assessments/SocAssessment/types/SocFormData'
import { SocFormField } from 'components/Assessments/SocAssessment/types/SocFormField'
import { SocAssessmentQuestionnaireItem } from 'components/Assessments/SocAssessment/types/questionnaire'

/**
 * Care coordination subsection adapter
 * Handles care coordination fields (5 fields)
 */
export class CareCoordinationAdapter extends BaseSubsectionAdapter<SocFormData> {
  extractFormData(
    flatAnswers: Record<string, QuestionnaireResponseItem>,
    _options?: AdapterOptions
  ): Partial<SocFormData> {
    const flatAnswersArray = Object.values(flatAnswers)

    // Direct field extractions for all care coordination fields
    const previousAppointments = getAnswerValuesFromItems(
      flatAnswersArray,
      SocAssessmentQuestionnaireItem.MEDICAL_BACKGROUND_CARE_COORDINATION_PREVIOUS_APPOINTMENTS
    )?.at(0)

    const futureAppointments = getAnswerValuesFromItems(
      flatAnswersArray,
      SocAssessmentQuestionnaireItem.MEDICAL_BACKGROUND_CARE_COORDINATION_FUTURE_APPOINTMENTS
    )?.at(0)

    const careTeamCoordination = getAnswerValuesFromItems(
      flatAnswersArray,
      SocAssessmentQuestionnaireItem.MEDICAL_BACKGROUND_CARE_COORDINATION_CARE_TEAM_COORDINATION
    )?.at(0)

    const ordersForTreatment = getAnswerValuesFromItems(
      flatAnswersArray,
      SocAssessmentQuestionnaireItem.MEDICAL_BACKGROUND_CARE_COORDINATION_ORDERS_FOR_TREATMENT
    )?.at(0)

    const dateOfVerbalCommunication = getAnswerValuesFromItems(
      flatAnswersArray,
      SocAssessmentQuestionnaireItem.MEDICAL_BACKGROUND_CARE_COORDINATION_DATE_OF_VERBAL_COMMUNICATION
    )?.at(0)

    return {
      [SocFormField.CARE_COORDINATION_PREVIOUS_APPOINTMENTS]: previousAppointments,
      [SocFormField.CARE_COORDINATION_FUTURE_APPOINTMENTS]: futureAppointments,
      [SocFormField.CARE_COORDINATION_CARE_TEAM_COORDINATION]: careTeamCoordination,
      [SocFormField.CARE_COORDINATION_ORDERS_FOR_TREATMENT]: ordersForTreatment,
      [SocFormField.CARE_COORDINATION_DATE_OF_VERBAL_COMMUNICATION]: dateOfVerbalCommunication
    }
  }

  buildFlatAnswers(): FlatAnswerMutation[] {
    return [
      {
        linkId:
          SocAssessmentQuestionnaireItem.MEDICAL_BACKGROUND_CARE_COORDINATION_PREVIOUS_APPOINTMENTS,
        value: this.getFormDataField(SocFormField.CARE_COORDINATION_PREVIOUS_APPOINTMENTS)
      },
      {
        linkId:
          SocAssessmentQuestionnaireItem.MEDICAL_BACKGROUND_CARE_COORDINATION_FUTURE_APPOINTMENTS,
        value: this.getFormDataField(SocFormField.CARE_COORDINATION_FUTURE_APPOINTMENTS)
      },
      {
        linkId:
          SocAssessmentQuestionnaireItem.MEDICAL_BACKGROUND_CARE_COORDINATION_CARE_TEAM_COORDINATION,
        value: this.getFormDataField(SocFormField.CARE_COORDINATION_CARE_TEAM_COORDINATION)
      },
      {
        linkId:
          SocAssessmentQuestionnaireItem.MEDICAL_BACKGROUND_CARE_COORDINATION_ORDERS_FOR_TREATMENT,
        value: this.getFormDataField(SocFormField.CARE_COORDINATION_ORDERS_FOR_TREATMENT)
      },
      {
        linkId:
          SocAssessmentQuestionnaireItem.MEDICAL_BACKGROUND_CARE_COORDINATION_DATE_OF_VERBAL_COMMUNICATION,
        value: this.getFormDataField(SocFormField.CARE_COORDINATION_DATE_OF_VERBAL_COMMUNICATION)
      }
    ]
  }
}
